module.exports = __webpack_public_path__ + "static/img/ausente.7c74090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/ausente.png
// module id = 232
// module chunks = 1